
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.906 4c.697 0 1.125.031 1.125.031l.906.031.031.906s.099 1.758-.094 3.813-.515 4.453-1.969 5.906c-1.213 1.212-4.488 3.737-7.563 6.094-.624.478-.607.466-1.188.906l.094 1.688a3.98 3.98 0 01-1.469 3.313l-2.563 2.094-1.281 1.031-.344-1.625-.656-3.281-3.844-3.844-3.281-.656-1.625-.313 1.031-1.313 2.094-2.563a3.98 3.98 0 013.313-1.469l1.719.094c.43-.564.41-.55.875-1.156 2.353-3.068 4.893-6.331 6.125-7.563 1.466-1.466 3.826-1.81 5.875-2a30.023 30.023 0 012.688-.125zM25 6c-.398.001-.91.03-1.594.094-1.886.175-3.973.754-4.656 1.438-.918.918-3.626 4.321-5.969 7.375-2.064 2.692-3.463 4.604-3.875 5.156l3.063 3.063c.544-.406 2.449-1.862 5.156-3.938 3.062-2.347 6.451-5.046 7.344-5.938.651-.651 1.229-2.761 1.406-4.656.129-1.375.105-1.982.094-2.563-.288-.007-.571-.033-.969-.031zm-4.562 3.531c1.117 0 2.031.915 2.031 2.031s-.915 2.031-2.031 2.031-2-.915-2-2.031.883-2.031 2-2.031zM8.5 16.75a2.004 2.004 0 00-1.656.75l-1.031 1.25 1.344.281c.132-.176 1.116-1.454 1.719-2.25zm-2.281 5.188l1.406 1.406c-.377.377-.82 1.323-1.125 2.156.798-.29 1.679-.679 2.125-1.125l1.406 1.406c-.894.894-2.079 1.385-3.063 1.719s-1.781.469-1.781.469l-1.469.281.313-1.469s.155-.82.5-1.813.833-2.176 1.688-3.031zm9 1.187c-.797.598-2.074 1.588-2.25 1.719l.281 1.344 1.281-1.031a1.976 1.976 0 00.719-1.656z"}})])
          )
        }
      }
    